// src/utils/axiosInstance.js
import axios from "axios";
import config from "../config"; // Adjust path if needed

const axiosInstance = axios.create({
  baseURL: `${config.url}/api/admin`, // Root API path
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminAuthToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
